// Shared between StepStatusAutomation.jsx and StepLeadSource.jsx -- both reference the same
// backend LeadStatus enum (SalesManager.Domain.Leads.Enums.LeadStatus) for their status selects,
// so the option list/values live in one place instead of two copies drifting apart.

export const LEAD_STATUS_OPTIONS = [
    { value: "New", label: "Nowy" },
    { value: "ContactAttempted", label: "Próba kontaktu" },
    { value: "Contacted", label: "Skontaktowano" },
    { value: "Conversation", label: "W rozmowie" },
    { value: "Qualifying", label: "Kwalifikacja" },
    { value: "Qualified", label: "Zakwalifikowany" },
    { value: "Interested", label: "Zainteresowany" },
    { value: "ConversionProposed", label: "Zaproponowano konwersję" },
    { value: "Converted", label: "Skonwertowany" },
    { value: "NotInterested", label: "Niezainteresowany" },
    { value: "NoResponse", label: "Brak odpowiedzi" },
    { value: "Disqualified", label: "Zdyskwalifikowany" },
    { value: "HandedToHuman", label: "Przekazano człowiekowi" },
];
